import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { message, Spin, Row, Col, Typography } from "antd";
import { actions, Types } from "../state";
import useFetchInfo from "../../../common/hook/useFetchInfo";
import { AuthStatus, FetchStatus } from "../../../common/constant";
import { useGoMyBlogMain } from "../../../common/hook/useGoMyBlogMain";

export default function SignupVerify() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { fetchStatus } = useFetchInfo(Types.FetchVerifyEmail);
  const authStatus = useSelector((state) => state.auth.status);
  const goMyBlogMain = useGoMyBlogMain();
  const retryCount = useRef(0);
  const MAX_RETRY = 10;
  const [retryTrigger, setRetryTrigger] = useState(0);

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      message.error("유효하지 않은 인증 링크입니다.");
      return;
    }
    dispatch(actions.fetchVerifyEmail(token));
  }, []);

  useEffect(() => {
    if (fetchStatus === FetchStatus.Fail) {
      message.error("인증에 실패했습니다. 링크가 만료되었을 수 있습니다.");
    }
  }, [fetchStatus]);

  // SSO 인증 완료 후 Kafka 동기화 지연으로 Blog DB에 유저가 없을 수 있어 재시도
  // authStatus가 NotLogin으로 유지되면 useEffect가 재실행되지 않으므로 retryTrigger로 강제 재실행
  useEffect(() => {
    if (fetchStatus !== FetchStatus.Success) return;
    if (authStatus === AuthStatus.Login) return;
    if (retryCount.current >= MAX_RETRY) return;

    const timer = setTimeout(() => {
      retryCount.current += 1;
      dispatch(actions.fetchUser());
      setRetryTrigger((prev) => prev + 1);
    }, 1000);
    return () => clearTimeout(timer);
  }, [fetchStatus, authStatus, dispatch, retryTrigger]);

  useEffect(() => {
    if (authStatus === AuthStatus.Login) {
      message.success("회원가입이 완료되었습니다!");
      goMyBlogMain();
    }
  }, [authStatus, goMyBlogMain]);

  return (
    <Row justify="center" align="middle" style={{ height: "100vh" }}>
      <Col style={{ textAlign: "center" }}>
        <Spin size="large" />
        <Typography.Title level={4} style={{ marginTop: 24 }}>
          이메일 인증 중...
        </Typography.Title>
      </Col>
    </Row>
  );
}
